import { UsedProductsList } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetUsedProductsListResponse } from "../schema/GetUsedProductsListResponse";
import { mapUsedProductList } from "../../mappers/usedProductListMapper";

export const getUsedProductsListBySearch = async (searchModel: string): Promise<UsedProductsList> => {
    const client = ApiClient.getInstance()

    const response = await client.get<GetUsedProductsListResponse>(`used-products/by-search-bar?model=${searchModel}`)

    const mappedResponse = mapUsedProductList(response)

    return mappedResponse;
}